import UbahStockFisik from "./UbahStockFisik";

export default UbahStockFisik;
